export default __webpack_public_path__ + "static/l2-content-img-2-54339402510c4d66a9d1121a828d863a.png";